<script>
  import { Line, mixins } from 'vue-chartjs'
  const { reactiveData } = mixins

  export default {
    extends: Line,
    mixins: [reactiveData],
    props: ['data'],
    mounted () {
      this.renderChart(this.chartData, this.options)
    },
    watch: {
      data: function (newData, oldData) {
        this.chartData = newData.report
        this.options = newData.options
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LineChart.vue?8a539496